import React, { useMemo, useState, useCallback } from "react";
import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ReferenceLine,
    ResponsiveContainer,
    LabelList,
    Label,
    Text,
  } from 'recharts';
import '../styles.css';

export const BarChartPanel = (props) => {

    const {data,tituloY, layout, bars, customToolTip, dataKeyXAsis} = props;

    const renderBar = useMemo(() =>{
        return bars.map((b)=>{
            return <Bar dataKey={b.dataKey} fill={b.fill} minPointSize={5} /> 
        })
    },[data, bars])

    const customizedTick = (propsTick) => {
        const { x, y, stroke, payload} = propsTick;

        return (
        <g transform={`translate(${x},${y})`} className="gChart">
            <text x={0} y={0} dy={16} textAnchor="middle" fill="#666" fontSize="12px" width={75} verticalAnchor="start">
                <tspan>{payload.value}</tspan>
            </text>
        </g>
        );
    }

    // const getXAsis = useMemo(()=>{
    //     return layout && layout === 'vertical' ? 
    //     <XAxis label={{ value: tituloY, angle: 0, position: 'insideLeft' }} tick={{fontSize:12}}/> : 
    //     <XAxis dataKey={dataKeyXAsis} tick={customizedTick}/>
    // },[layout])

    // const getYAsis = useMemo(()=>{
    //     return layout && layout === 'vertical' ? 
    //     <YAxis dataKey={dataKeyXAsis} type="category" scale="band" tick={customizedTick}/> : 
    //     <YAxis label={{ value: tituloY, angle: -90, position: 'insideLeft' }} tick={{fontSize:12}}/>
    // },[layout])


    return data && data.length>0 ? (
        <ResponsiveContainer width="100%" height="100%" style={{overflow:'auto'}}>
        <BarChart
            width={100}
            height={300}
            data={data}
            //layout={layout?layout:'horizontal'}
            margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 5,
            }}
        >
            <CartesianGrid strokeDasharray="1 1" />
            {/* {getXAsis}
            {getYAsis} */}
            <XAxis dataKey={dataKeyXAsis} tick={customizedTick}/>
            <YAxis label={{ value: tituloY, angle: -90, position: 'insideLeft' }} tick={{fontSize:12}}/>
            <Tooltip content={customToolTip}/>
            <Legend verticalAlign="bottom"/>
            {renderBar}
        </BarChart>
        </ResponsiveContainer>
      ) : null
}